<template>
  <div class="card">
    <div class="message-list">
      <div
        class="message-list__item"
        v-for="message in messageArray"
        :key="message.eventMessageId"
      >
        <message-preview :message-data="message" />
        <el-button
          class="message-list__item-reply"
          type="primary"
          plain
          @click="handleReply(message)"
        >
          Reply
        </el-button>
      </div>
    </div>

    <div v-if="messageArray.length === 0">No messages</div>

    <el-dialog
      v-model="isReplyFormVisible"
      width="40%"
      title="Reply to message"
    >
      <el-form :rules="replyRules" :model="replyForm" ref="replyForm">
        <el-form-item prop="text" :error="replyErrors.text" label="Message">
          <el-input v-model="replyForm.text" type="textarea" :rows="4" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelReply">
          Cancel
        </el-button>
        <el-button
          type="primary"
          @click="validateReplyForm"
          :disabled="isButtonDisabled('send-message')"
        >
          Send message
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MessagePreview from '@/components/messages/MessagePreview.vue';
import { getEventMessages } from '@/api/events.js';
import { sendMessageToUser } from '@/api/profile.js';
import { parseErrorsByFields } from '@/utils/index.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'EventMessages',
  props: {
    eventId: {
      type: Number,
      required: true,
    },
  },
  mixins: [disableButton],
  components: {
    MessagePreview,
  },
  data() {
    return {
      messageArray: [],
      replyForm: { text: null },
      replyErrors: { text: null },
      replyRules: {
        text: [
          { required: true, message: 'Please enter message', trigger: 'input' },
        ],
      },

      isReplyFormVisible: false,
      messageToReply: null,
    };
  },
  methods: {
    parseErrorsByFields,
    showMessage,
    async fetchEventMessages() {
      const { eventId } = this;
      const { data, success } = await getEventMessages({ eventId });

      if (success) {
        this.messageArray = data.items;
      }
    },
    async requestSendMessage() {
      this.disableButton('send-message');
      const { userId } = this.messageToReply.writtenBy;
      const { text } = this.replyForm;
      const { success } = await sendMessageToUser({ userId, text });
      this.enableButton('send-message');

      if (success) {
        this.fetchEventMessages();
        this.clearForm();
        this.clearErrors();
        this.handleCancelReply();
        this.showMessage({
          type: 'success',
          message: 'Message has been sent',
        });
      } else if (errors) {
        this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
      }
    },
    handleReply(message) {
      this.isReplyFormVisible = true;
      this.messageToReply = message;
    },
    handleCancelReply() {
      this.isReplyFormVisible = false;
      this.messageToReply = null;
    },
    validateReplyForm() {
      if (this.$refs.replyForm) {
        this.$refs.replyForm.validate();
      }

      const { text } = this.replyForm;
      if (text && text.trim()) {
        this.requestSendMessage();
      }
    },
    clearForm() {
      this.replyForm.text = null;
    },
    clearErrors() {
      this.$refs.replyForm.clearValidate();
    },
  },
  created() {
    this.fetchEventMessages();
  },
  watch: {
    eventId() {
      this.fetchEventMessages();
    },
  },
};
</script>
